import React, { useContext, useEffect, useState } from 'react';
import { Card, CardActions, CardContent, CircularProgress, Divider, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
    StyledColumnBox,
    StyledGreenButton,
    StyledMediumTypography,
    StyledNormalTypography
} from '../../theme/StyledElements';
import { UserContext } from '../../providers/UserProvider';
import { registerProducerOnStripe } from '../../services/storageFunctions';
import { useNavigate } from 'react-router-dom';

const StyledCard = styled(Card)(() => ({
    height: '550px',
    width: '720px',
    boxShadow: '0px 3px 6px #00000029',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px'
}));

const StyledSubscriptionButton = styled(StyledGreenButton)(() => ({
    height: '35px',
    background: '#134C03',
    borderRadius: '4px',
    color: '#FFFFFF',
    padding: '15px',
    marginTop: '0px',
    fontWeight: 700
}));

const StyledSubscriptionContent = styled(StyledMediumTypography)(() => ({
    marginTop: '10px'
}));

const StyledBox = styled(StyledColumnBox)(() => ({
    marginBottom: '60px',
    alignItems: 'center'
}));

export function Subscription(): React.ReactElement {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const user = useContext(UserContext);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (user) {
            if (user && user.stripeId) {
                navigate('/');
            }
        }
    }, [user]);

    const handleButtonClick = async (): Promise<void> => {
        setLoading(true);
        if (user && user.mail && user.idProducteur) {
            const url = await registerProducerOnStripe(user.mail, user.idProducteur);
            window.location.href = url;
        }
    };

    return (
        <StyledBox>
            <StyledCard variant="elevation">
                <CardContent>
                    <StyledMediumTypography color="#E37F1E" variant="h3" sx={{ marginTop: '20px' }}>
                        {t('welcomeOfferForFirstCustomers')}
                    </StyledMediumTypography>
                    <StyledMediumTypography variant="caption">
                        {t('10PercentRetrocessionSalesOnMobile')}
                    </StyledMediumTypography>
                    <Divider sx={{ borderColor: '#E37F1E', margin: '20px 0px' }} />
                    <StyledColumnBox>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent1')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent2')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent3')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent4')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent5')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent6')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent7')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent8')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent9')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent10')}
                        </StyledSubscriptionContent>
                        <StyledMediumTypography variant="h3" sx={{ marginTop: '20px' }}>
                            {t('simple&WithoutObligation')}
                        </StyledMediumTypography>
                    </StyledColumnBox>
                </CardContent>
                <CardActions sx={{ display: 'flex', flexDirection: 'column' }}>
                    {loading && (
                        <CircularProgress
                            style={{
                                color: '#134C03',
                                height: '25px',
                                width: '25px'
                            }}
                        />
                    )}
                    {!loading && (
                        <StyledSubscriptionButton
                            onClick={(): Promise<void> => handleButtonClick()}>
                            <StyledMediumTypography variant="caption" color="#FFFFFF">
                                {t('toStart')}
                            </StyledMediumTypography>
                        </StyledSubscriptionButton>
                    )}
                </CardActions>
                <StyledNormalTypography variant="overline" sx={{ textTransform: 'initial' }}>
                    {t('offerSubjectToTerms&Condtions')}
                </StyledNormalTypography>
            </StyledCard>
        </StyledBox>
    );
}
